import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import { getUsers, deleteUser, changeStatusUser } from '../../../../api/user'
import { Button, Tooltip, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import ToggleOffIcon from '@material-ui/icons/ToggleOff'
import ToggleOnIcon from '@material-ui/icons/ToggleOn'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'
import { shallowEqual, useSelector } from 'react-redux'

const SEGMENT = { turista: 'Turista', residente: 'Ciudadano' }
const PROVIDER = { local: 'Comarca', pid: 'PID OAuth', both: 'Comarca + PID' }

function getData(users) {
  return users.map((u) => ({
    id: u._id,
    name: u.fullName,
    email: u.email,
    role: u.role,
    provider: PROVIDER[u.authProvider] || u.authProvider || 'Propio',
    segment: SEGMENT[u.segment] || u.segment || 'Turista',
    active: u.active,
    createdAt: u.createdAt,
  }))
}

export default function UsersPage() {
  const [raw, setRaw] = useState([])
  const [data, setData] = useState([])
  const [userId, setUserId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const [segmentFilter, setSegmentFilter] = useState('')
  const history = useHistory()
  const user = useSelector((store) => store.authentication?.user, shallowEqual)

  function buttonFormatter(cell) {
    const elem = raw.find((item) => item._id === cell)
    return (
      <>
        <Tooltip title="Edit">
          <Button style={buttonsStyle} size="small" onClick={() => history.push('/edit-user/' + cell)}>
            <EditIcon />
          </Button>
        </Tooltip>
        {user?.role === 'admin' && (
          <>
            <Tooltip title={elem?.active ? 'Disable' : 'Enable'}>
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserId(elem)
                  setOpenConfirmDialog(1)
                }}
              >
                {elem?.active ? <ToggleOffIcon /> : <ToggleOnIcon style={{ color: 'red' }} />}
              </Button>
            </Tooltip>
            <Tooltip title="Delete">
              <Button
                style={buttonsStyle}
                size="small"
                onClick={() => {
                  setUserId(cell)
                  setOpenConfirmDialog(2)
                }}
              >
                <DeleteIcon />
              </Button>
            </Tooltip>
          </>
        )}
      </>
    )
  }

  const columns = [
    { dataField: 'name', text: 'Nombre', sort: true },
    { dataField: 'email', text: 'Email', sort: true },
    { dataField: 'role', text: 'Rol', sort: true },
    { dataField: 'provider', text: 'Origen', sort: true },
    { dataField: 'segment', text: 'Segmento', sort: true },
    { dataField: 'createdAt', text: 'Creado', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter },
  ]

  useEffect(() => {
    getUsers()
      .then((res) => {
        if (res.status === 200) {
          setRaw(res.data)
          setRefresh(false)
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudieron cargar los usuarios.' })
      })
  }, [refresh])

  useEffect(() => {
    let filtered = raw.filter((u) => u.role !== 'admin')
    if (segmentFilter) filtered = filtered.filter((u) => (u.segment || 'turista') === segmentFilter)
    setData(getData(filtered))
  }, [raw, segmentFilter])

  return (
    <Card>
      <CardHeader title="Usuarios (comarca + PID)" />
      <CardBody>
        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
          <FormControl variant="outlined" size="small" style={{ minWidth: 140 }}>
            <InputLabel>Segmento</InputLabel>
            <Select value={segmentFilter} onChange={(e) => setSegmentFilter(e.target.value)} label="Segmento">
              <MenuItem value="">Todos</MenuItem>
              <MenuItem value="turista">Turista</MenuItem>
              <MenuItem value="residente">Ciudadano</MenuItem>
            </Select>
          </FormControl>
        </div>
        <Table data={data} columns={columns} />
        <ConfirmDialog
          title={`¿${userId?.active ? 'Desactivar' : 'Activar'} este usuario?`}
          open={openConfirmDialog === 1}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            changeStatusUser(userId._id || userId.id, !userId?.active)
              .then((res) => {
                if (res.status === 200) {
                  alertSuccess({ title: 'OK', customMessage: 'Estado actualizado.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo cambiar el estado.' })
              })
          }}
        />
        <ConfirmDialog
          title="¿Eliminar este usuario?"
          open={openConfirmDialog === 2}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteUser(userId)
              .then((res) => {
                if (res.status === 204 || res.status === 200) {
                  alertSuccess({ title: 'Eliminado', customMessage: 'Usuario eliminado.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo eliminar.' })
              })
          }}
        />
      </CardBody>
    </Card>
  )
}
